<template>
  <div class="service">
    <div class="appCode">
      <div
        class="box"
        @mouseenter="isHover1 = true"
        @mouseleave="isHover1 = false"
      >
        <el-popover placement="left" trigger="hover">
          <div class="codeBox">
            <p class="title1">MANA</p>
            <p class="title2">{{ $t("global.全球新媒体艺术平台") }}</p>
            <p class="title3">{{ $t("video.扫码下载APP") }}</p>
            <img
              class="codeImg"
              src="/static/home/MANA_App_download_2@2x.png"
              alt=""
            />
          </div>
          <img
            slot="reference"
            class="sideImg"
            :src="
              !isHover1
                ? '/static/home/side_app_dl_btn@2x.png'
                : '/static/home/side_app_dl_btn_hover@2x.png'
            "
            alt=""
          />
        </el-popover>
      </div>
      <div
        class="topicon"
        @mouseenter="isHover2 = true"
        @mouseleave="isHover2 = false"
      >
        <img
          v-if="isShow"
          @click="goToTop"
          class="topImg"
          :src="
            !isHover2
              ? '/static/home/top_btn@2x.png'
              : '/static/home/top_btn_hover@2x.png'
          "
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "service",
  data() {
    return {
      isHover1: false,
      isHover2: false,
      isShow: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      var scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scroll > 200) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    goToTop() {
      timer = requestAnimationFrame(function fn() {
        var oTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (oTop > 0) {
          document.body.scrollTop = document.documentElement.scrollTop =
            oTop - 200;
          timer = requestAnimationFrame(fn);
        } else {
          this.goToTop(timer);
        }
      });
    },
  },
  computed: {
    language() {
      return this.$language();
    },
  },
};
</script>

<style lang="stylus" scoped>
.codeBox {
  text-align: center;

  .title1 {
    font-size: 18px;
    font-weight: 600;
    color: #0A0A0A;
    line-height: 24px;
  }
  .title2 {
    font-size: 18px;
    font-weight: 400;
    color: #0A0A0A;
    line-height: 24px;
  }

  .title3 {
    font-size: 13px;
    font-weight: 400;
    color: #999999;
    margin: 8px 0;
    text-align: center;
  }

  .codeImg {
    width: 105px;
    height: 105px;
  }
}

.service {
  position: fixed;
  right: 16px;
  bottom: 14%;
  width: 44px;
  z-index: 9999;

  .appCode {
    .box {
      width: 44px;

      .sideImg {
        width: 44px;
        height: auto;
      }
    }
  }

  .topicon {
    width: 44px;
    height: 44px;
    margin-top: 6px;

    .topImg {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/service.vue